import {
  BookOpen,
  Camera,
  ChevronRight,
  EllipsisVertical,
  MessagesSquare,
  Pencil,
  Trash2,
} from "lucide-react";
import React, { useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Logo from "../../../assets/image.png";
import AssociateModal from "../AssociateModal";
import { useDispatch, useSelector } from "react-redux";
import { hanldeGroups } from "../../../redux/groupData";
import apiServiceHandler from "../../../service/apiService";
import toastr from "toastr";
import NoAccessModal from "../../Content-Library/NoAccessModal";
import { collection, getDocs, updateDoc } from "firebase/firestore";
import { firestore } from "../../../firebase";

const GroupCard = ({ group }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const coursePath = pathname.split("/").includes("courses");
  const dispatch = useDispatch();
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const isAdmin = userDetails?.admin;
  const [noAccessModal, setNoAccessModal] = useState(false);
  const toggleNoAccessModal = () => {
    setNoAccessModal(!noAccessModal);
  };

  const [openPopover, setOpenPopover] = useState(null);
  const [associateModal, setAssociateModal] = useState(false);
  const fileInputRef = useRef(null);
  const unreadGroupNotifications = useSelector(
    (state) => state.groupData.unreadGroupNotifications
  );

  const toggleAssociateModal = () => {
    setAssociateModal(!associateModal);
    setOpenPopover(null);
  };

  const togglePopover = (groupId) => {
    setOpenPopover(openPopover === groupId ? null : groupId); // Toggle popover
  };

  const removeGroup = async (id) => {
    const payload = {
      groupId: id,
    };

    try {
      const response = await apiServiceHandler(
        "POST",
        "api/groups/remove",
        payload
      );
      if (response.status) {
        toastr.success(response.message);
        dispatch(hanldeGroups(true));

        const notifsCollectionRef = collection(firestore, "notifs");

        const snapshot = await getDocs(notifsCollectionRef);

        const updatePromises = snapshot.docs.map(async (docSnapshot) => {
          const docRef = docSnapshot.ref;
          const data = docSnapshot.data();

          const isGroupMember = group?.members.some(
            (member) => member === docSnapshot.id
          );

          if (
            isGroupMember &&
            data.notifications &&
            Array.isArray(data.notifications)
          ) {
            const updatedNotifications = data.notifications.map(
              (notification) => {
                if (notification.groupId === id) {
                  return { ...notification, read: true };
                }
                return notification;
              }
            );

            await updateDoc(docRef, { notifications: updatedNotifications });
          }
        });

        await Promise.all(updatePromises);
      }
    } catch (error) {
      console.error("Error associating course:", error);
    }
  };

  const handleSaveBanner = async (file) => {
    if (!file) return;
    const data = new FormData();
    data.append("file", file);
    data.append("id", group?._id);
    data.append("name", group.name);
    data.append("description", group.description);
    data.append("small", true);
    group?.members?.forEach((member) => {
      data.append("members[]", member);
    });

    try {
      const response = await apiServiceHandler(
        "POST",
        "api/groups/update",
        data,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      if (response.status) {
        toastr.success("Banner updated successfully!");
        dispatch(hanldeGroups(true));
      } else {
        toastr.error("Something went wrong! Please try again later.");
      }
    } catch (error) {
      console.error("Error updating group:", error);
    }
  };

  const handleCameraClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      handleSaveBanner(file);
    }
  };

  const createChat = async (groupId) => {
    const payload = { groupId: groupId };

    try {
      const response = await apiServiceHandler(
        "POST",
        "api/chat/update/group",
        payload
      );
      if (response.status) {
        toastr.success(response.message);
        setOpenPopover(null);
      }
    } catch (error) {
      console.error("Error creating chat of selected group", error);
    }
  };

  return (
    <>
      <div className="drip-card--content">
        <div className="card__wrapper">
          <div className="card-image">
            {!coursePath && (
              <button
                style={{
                  position: "absolute",
                  top: "8%",
                  left: "10%",
                  color: "white",
                  zIndex: "999",
                  background: "none",
                  border: "none",
                }}
                onClick={handleCameraClick}
              >
                <Camera
                  style={{
                    width: "20px",
                    height: "20px",
                  }}
                />
              </button>
            )}
            <img
              src={
                group?.small_banner_image
                  ? group?.small_banner_image
                  : group?.banner_image
              }
            />
          </div>
          <input
            type="file"
            ref={fileInputRef}
            style={{ display: "none" }}
            onChange={handleFileChange}
          />
          <div className="card__heading">
            <div className="jurni-font-roboto">
              {group?.name.length > 35
                ? `${group?.name.slice(0, 35)}...`
                : group?.name}
              {unreadGroupNotifications.length > 0 &&
                unreadGroupNotifications?.some(
                  (notification) =>
                    notification.groupId === group?._id && !notification.read
                ) && (
                  <span
                    className="badge"
                    style={{
                      backgroundColor: "#26262f",
                      fontSize: "12px",
                      width: "fit-content",
                      height: "25px",
                      lineHeight: "1rem",
                      borderRadius: "10px",
                      textAlign: "center",
                      boxShadow: "2px 0px 12px #26262f",
                      marginLeft: "1rem",
                    }}
                  >
                    New Posts
                  </span>
                )}
            </div>
          </div>
          <div className="card__content">
            <div className="card-meta-item">
              <div className="card-meta-item-icon"></div>
              <div className="card-meta-item-content"></div>
            </div>
            <div className="steps-info" style={{ marginTop: "0.6rem" }}>
              <div className="icon-brand">
                <span className="icon--members">
                  <svg
                    viewBox="0 0 20 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="icon__svg"
                    preserveAspectRatio="xMidYMid meet"
                    style={{ width: "20px", height: "20px" }}
                  >
                    <path
                      d="M10 0a3 3 0 100 6 3 3 0 000-6zM3.5 1a2.5 2.5 0 100 5 2.5 2.5 0 000-5zm13 0a2.5 2.5 0 100 5 2.5 2.5 0 000-5zM10 18a4.505 4.505 0 01-4.5-4.5V8.75C5.5 7.785 6.285 7 7.25 7h5.5c.965 0 1.75.785 1.75 1.75v4.75c0 2.481-2.019 4.5-4.5 4.5zm-5.5-4.5V8.75c0-.664.237-1.274.63-1.75H1.75C.785 7 0 7.785 0 8.75V12a4.005 4.005 0 005.03 3.865l.01-.004A5.459 5.459 0 014.5 13.5zm11 0V8.75c0-.664-.237-1.274-.63-1.75h3.38c.965 0 1.75.785 1.75 1.75V12a4.005 4.005 0 01-5.03 3.865l-.01-.004c.342-.716.54-1.516.54-2.361z"
                      fill="#000"
                    ></path>
                  </svg>
                </span>
              </div>
              <div className="step-text">
                <span>{group?.members?.length} Members</span>
              </div>
            </div>
          </div>
          <div
            className="card__action-menu"
            onMouseLeave={() => setOpenPopover(null)}
          >
            {isAdmin && (
              <div className="dropdown-activator">
                {!coursePath && (
                  <button
                    className="btn-card-action"
                    onClick={() => togglePopover(group?._id)}
                  >
                    <span className="icon--menu-dots">
                      <EllipsisVertical />
                    </span>
                  </button>
                )}
              </div>
            )}
            {openPopover === group._id && (
              <div className="group-dropdown-popover">
                <div className="group-dropdown-content">
                  <div className="group-menu">
                    {/* <div className="group-menu-item">
                      <span className="icon__settings">
                        <Settings
                          style={{
                            width: "20px",
                            height: "20px",
                            color: "#d1b794",
                          }}
                        />
                      </span>
                      <div className="group-menu-item__label">
                        Group Settings
                      </div>
                    </div> */}
                    <div
                      className="group-menu-item"
                      onClick={() => removeGroup(group?._id)}
                    >
                      <span className="icon__settings">
                        <Trash2
                          style={{
                            width: "20px",
                            height: "20px",
                            color: "#d1b794",
                          }}
                        />
                      </span>
                      <div className="group-menu-item__label">Remove Group</div>
                    </div>
                    <div
                      className="group-menu-item"
                      onClick={toggleAssociateModal}
                    >
                      <span className="icon__settings">
                        <BookOpen
                          style={{
                            width: "20px",
                            height: "20px",
                            color: "#d1b794",
                          }}
                        />
                      </span>
                      <div className="group-menu-item__label">
                        Associate Course
                      </div>
                    </div>
                    <div
                      className="group-menu-item"
                      onClick={() =>
                        navigate(`/groups/group/edit/${group?._id}`)
                      }
                    >
                      <span className="icon__settings">
                        <Pencil
                          style={{
                            width: "20px",
                            height: "20px",
                            color: "#d1b794",
                          }}
                        />
                      </span>
                      <div className="group-menu-item__label">Edit Group</div>
                    </div>
                    <div
                      className="group-menu-item"
                      onClick={() => createChat(group?._id)}
                    >
                      <span className="icon__settings">
                        <MessagesSquare
                          style={{
                            width: "20px",
                            height: "20px",
                            color: "#d1b794",
                          }}
                        />
                      </span>
                      <div className="group-menu-item__label">Create Chat</div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="card__action">
          <button
            className="courses-card__btn"
            onClick={() =>
              group.members.includes(userDetails?._id) || isAdmin
                ? navigate(`/groups/group/${group._id}`)
                : toggleNoAccessModal()
            }
          >
            <span className="courses-card__btn">Visit</span>
          </button>
        </div>
      </div>
      <AssociateModal
        isOpen={associateModal}
        onClose={toggleAssociateModal}
        id={group._id}
      />
      <NoAccessModal isOpen={noAccessModal} onClose={toggleNoAccessModal} />
    </>
  );
};

export default GroupCard;
